(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wawa-rug-finder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wawa-rug-finder]').forEach((section) => {
    const form = section.querySelector('[data-rug-finder-form]');
    const axes = Array.from(form.querySelectorAll('[data-finder-axis]'));

    const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);

    axes.forEach((axis) => {
      const minimum = Number(axis.dataset.min);
      const maximum = Number(axis.dataset.max);
      const fromRange = axis.querySelector('[data-from-range]');
      const toRange = axis.querySelector('[data-to-range]');
      const fromNumber = axis.querySelector('[data-from-number]');
      const toNumber = axis.querySelector('[data-to-number]');

      const synchronise = (changed) => {
        let from = changed === fromNumber ? Number(fromNumber.value) : Number(fromRange.value);
        let to = changed === toNumber ? Number(toNumber.value) : Number(toRange.value);
        from = clamp(from, minimum, maximum);
        to = clamp(to, minimum, maximum);

        if (from > to) {
          if (changed === fromRange || changed === fromNumber) {
            from = to;
          } else {
            to = from;
          }
        }

        fromRange.value = from;
        toRange.value = to;
        fromNumber.value = from;
        toNumber.value = to;
        const span = maximum - minimum || 1;
        axis.style.setProperty('--range-min', `${((from - minimum) / span) * 100}%`);
        axis.style.setProperty('--range-max', `${((to - minimum) / span) * 100}%`);
      };

      [fromRange, toRange].forEach((control) => control.addEventListener('input', () => synchronise(control)));
      [fromNumber, toNumber].forEach((control) => {
        control.addEventListener('input', () => {
          const from = Number(fromNumber.value), to = Number(toNumber.value);
          if (fromNumber.value !== '' && toNumber.value !== '' && from >= minimum && to <= maximum && from <= to) {
            fromRange.value = from;
            toRange.value = to;
          }
        });
        control.addEventListener('change', () => synchronise(control));
      });
      synchronise(fromRange);
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const destination = new URL(form.action, window.location.origin);

      axes.forEach((axis, index) => {
        const minimum = Number(axis.dataset.min);
        const maximum = Number(axis.dataset.max);
        const from = clamp(Number(axis.querySelector('[data-from-number]').value), minimum, maximum);
        const to = Math.max(from, clamp(Number(axis.querySelector('[data-to-number]').value), minimum, maximum));

        if (from === minimum && to === maximum) {
          return;
        }

        if (index === 0) {
          destination.searchParams.set('filter.v.price.gte', from);
          destination.searchParams.set('filter.v.price.lte', to);
        } else {
          destination.searchParams.set(`${axis.dataset.queryPrefix}_from`, from);
          destination.searchParams.set(`${axis.dataset.queryPrefix}_to`, to);
        }
      });

      window.location.assign(destination.toString());
    });
  });

  } catch(e) { console.error(e); }
})();
})();
